export const locale = {
    lang: 'pt',
    data: {
        FORM_DYNAMIC: {
            DATE_FORMAT: 'dd/MM/yyyy',
        },
    },
};
